export class AdminGeofences {
}
//# sourceMappingURL=admin-geofences.js.map